import React from "react";
import Slider from "react-slick";
import { Text } from "../../common/styled";
import mediaQuery from "../../common/mediaQuery";
import "../style.css";

export default ({ text }) => {
  const { small } = mediaQuery();

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    arrows: false,
    autoPlay: true,
    autoPlaySpeed: 3000,
    slidesToShow: small ? 1 : 4,
    slidesToScroll: 1,
    appendDots: dots => <ul>{dots}</ul>
  };

  return (
    <Slider {...settings}>
      <div className={small ? "SlideContainerServices" : ""}>
        <div className={small ? "ServiceSlideMobile" : "ServiceSlide"}>
          <img
            className="ServiceIcon"
            src={require("../../../images/icones/alarme.png")}
            alt="apps"
          />
          <Text
            align="center"
            color="#222"
            weight="600"
            size={small ? "2.8vh" : "1.2vw"}
          >
            {text.getAlarme()[0]}
          </Text>
          <Text
            marginTop="2vh"
            size={small ? "2.5vh" : "1.1vw"}
            padding={small ? "0 2vh" : 0}
            weight={small ? "500" : "300"}
            align="center"
            color="#222222"
          >
            {text.getAlarme()[1]}
          </Text>
        </div>
      </div>

      <div className={small ? "SlideContainerServices" : ""} >
        <div className={small ? "ServiceSlideMobile" : "ServiceSlide"}>
          <img
            className="ServiceIcon"
            src={require("../../../images/icones/servidores.png")}
            alt="manutencao"
          />
          <Text
            align="center"
            color="#222"
            weight="600"
            size={small ? "2.8vh" : "1.2vw"}
          >
            {text.getServidor()[0]}
          </Text>
          <Text
            marginTop="2vh"
            size={small ? "2.5vh" : "1.1vw"}
            padding={small ? "0 2vh" : 0}
            weight={small ? "500" : "300"}
            align="center"
            color="#222222"
          >
            {text.getServidor()[1]}
          </Text>
        </div>
      </div>

      <div className={small ? "SlideContainerServices" : ""} >
        <div className={small ? "ServiceSlideMobile" : "ServiceSlide"}>
          <img
            className="ServiceIcon"
            src={require("../../../images/icones/camera.png")}
            alt="sites"
          />
          <Text
            align="center"
            color="#222"
            weight="600"
            size={small ? "2.8vh" : "1.2vw"}
          >
            {text.getCamera()[0]}
          </Text>
          <Text
            marginTop="2vh"
            size={small ? "2.5vh" : "1.1vw"}
            padding={small ? "0 2vh" : 0}
            weight={small ? "500" : "300"}
            align="center"
            color="#222222"
          >
            {text.getCamera()[1]}
          </Text>
        </div>
      </div>

      <div className={small ? "SlideContainerServices" : ""} >
        <div className={small ? "ServiceSlideMobile" : "ServiceSlide"}>
          <img
            className="ServiceIcon"
            src={require("../../../images/icones/cabeamento.png")}
            alt="sistemas"
          />
          <Text
            align="center"
            color="#222"
            weight="600"
            size={small ? "2.8vh" : "1.2vw"}
          >
            {text.getCabeamento()[0]}
          </Text>
          <Text
            marginTop="2vh"
            size={small ? "2.5vh" : "1.1vw"}
            padding={small ? "0 2vh" : 0}
            weight={small ? "500" : "300"}
            align="center"
            color="#222222"
          >
            {text.getCabeamento()[1]}
          </Text>
        </div>
      </div>
    </Slider>
  );
};
